'use client';

import {
  configureGladly,
  exposeGladlyHandler,
  loadGladly,
  restoreGladlySession,
  writeGladlySessionCookie
} from '@4patriots/gladly-chat';
import { ReactNode, useEffect } from 'react';

export default function GladlyProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    configureGladly({
        appId: process.env.GLADLY_APP_ID || '',
        env: process.env.ENV || 'sb'
      });
    restoreGladlySession();
    loadGladly()
    exposeGladlyHandler();
    return () => window.removeEventListener('beforeunload', writeGladlySessionCookie);
  }, []);

  return <>{children}</>;
}
